import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCommentDots} from "@fortawesome/free-solid-svg-icons/faCommentDots";
import {withRouter} from "react-router-dom";
import {confirmAlert} from "react-confirm-alert";
import CommentsDialog from "../../containers/startproj/Comments";


export default withRouter(function CommentsIcon(props){
 const { project} = props;

    function commentsConfirm(project){
        confirmAlert({
            customUI: ({onClose}) => {
                return(
                    <CommentsDialog onClose={onClose} projectId={project.id} project={project}/>
                );

            }
        });
    }
    return(
        <FontAwesomeIcon id={"cmticon"}
            icon={faCommentDots} pull={"right"} size ="lg" style={{cursor:'pointer'}}
            onClick={() =>  commentsConfirm(project)}>Comment</FontAwesomeIcon>


    )
})